export const ADD_COUPON = "ADD_COUPON";
export const ADD_LOYALTY = "ADD_LOYALTY";


export const addcoupon = (payload) =>{
    return {type:ADD_COUPON,payload}
}

export const addloyalty = (payload) =>{
    return {type:ADD_LOYALTY,payload}
}
